import { formatPrecisaoFloat } from "../../../utils";

export function tabProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export function totalItensLista(listaCondicionaisProdutos) {
  if (listaCondicionaisProdutos?.length) {
    const total = listaCondicionaisProdutos.reduce(
      (prevVal, elem) => prevVal + parseFloat(elem.totalItem),
      0
    );
    return total;
  }
}

export function calcularValorTotal(produto) {
  const total = parseFloat(produto?.valorUnitario) * produto?.quantidade;
  return total;
}

export function mapearEndereco(endereco) {
  return {
    ...endereco,
    cidade: endereco.cidade?.nome,
    codigoIbge: endereco.cidade?.codigoIbge,
    estado: endereco.cidade?.estado?.sigla,
    estadoId: endereco.cidade?.estadoId,
  };
}

export const mapearEnderecos = (enderecos, estados) => {
  return enderecos.map((endereco) => mapearEndereco(endereco, estados));
};

export function encontrarEnderecoPadrao(enderecos) {
  return enderecos.find((endereco) => endereco.padrao === true);
}

export function calculoDesconto(itens, condicional, porCemParaDecimal = true) {
  const total =
    totalItensLista(itens) +
    parseFloat(condicional?.acrescimo ?? 0) +
    parseFloat(condicional?.despesas ?? 0);
  let resultado;
  if (porCemParaDecimal) {
    const descontoPorcentagem = parseFloat(
      condicional?.descontoPorcentagem ?? 0
    );
    resultado = (descontoPorcentagem / 100) * total;
    resultado = formatPrecisaoFloat(resultado, 3);
  } else {
    const desconto = parseFloat(condicional?.desconto ?? 0);
    resultado = (desconto / formatPrecisaoFloat(total)) * 100;
    resultado = formatPrecisaoFloat(resultado, 3);
  }
  return resultado;
}
